

const ArrowSubmit = (props) => {
    const { className } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22.5px" height="24px" viewBox="0 0 15 16" className={className} ><path fill="currentColor" d="M12.49 7.14L3.44 2.27c-.76-.41-1.64.3-1.4 1.13l1.24 4.34q.075.27 0 .54l-1.24 4.34c-.24.83.64 1.54 1.4 1.13l9.05-4.87a.98.98 0 0 0 0-1.72Z"/></svg>
  )
}

export default ArrowSubmit
